import React, { useState, useEffect } from 'react';
import { IoMdEye } from 'react-icons/io';
import { Button, Pagination } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ViewWeightDisputes from '../../../component/b2c/models/viewWeightDisputes';
import { useMyContext } from '../../../context/MyContext';
import Sidebar from '../../../component/b2c/sidebar/sidebar';
import NavBar from '../../../component/b2c/navBar/navBar';
import PaginationItem from '@mui/material/PaginationItem';
import '../../../css/custom-scrollbar.css';
import { FaWeight } from 'react-icons/fa'
import { MdCheckCircle, MdCancel } from "react-icons/md";
import axios from 'axios';
import { FaDownload } from "react-icons/fa";
import { toast } from 'react-toastify';
import { dispute_action_admin, Base_Url, weightList } from '../../../config/config';

const AllWeightDisputes = () => {
    const [totalOrders, setTotalOrders] = useState(0);
    const { isDarkMode } = useMyContext();
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const { isToggleSidebar } = useMyContext();
    const [weights, setweights] = useState([]);
    const [selectedweight, setSelectedweight] = useState(null);
    const navigate = useNavigate();

    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);

    useEffect(() => {
        fetchAllDisputes();
    }, [page, limit]);

    const downloadCSV = () => {
        if (!weights || weights.length === 0) {
            toast.error("No data available to download");
            return;
        }

        const headers = [
            "Seller ID",
            "Waybill",
            "Initial Weight",
            "Dimension",
            "Product Description",
            "SKU",
            "Reversed Weight",
            "Price",
            "Status",
            "Date"
        ];

        const csvData = weights.map(weight => [
            weight.seller_id || '',
            weight.waybill || '',
            weight.initial_weight || '',
            weight.dimension || '',
            weight.product_des || '',
            weight.sku || '',
            weight.reversed_weight || '',
            weight.price || '',
            weight.status || '',
            weight.timestamp || ''
        ]);

        csvData.unshift(headers);

        const csvContent = csvData.map(row =>
            row.map(field => {
                const stringField = String(field);
                if (stringField.includes(',') || stringField.includes('"') || stringField.includes('\n')) {
                    return `"${stringField.replace(/"/g, '""')}"`;
                }
                return stringField;
            }).join(',')
        ).join('\n');

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', `weight_disputes_${new Date().toISOString().split('T')[0]}.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        toast.success("CSV file downloaded successfully!");
    };

    const handleAccept = async (row) => {
        const token = localStorage.getItem('token');
        const cus_id = localStorage.getItem('cus_id');
        const formData = new FormData();
        formData.append("waybill", row.waybill);
        formData.append("status", "Accept");
        formData.append("seller_id", row.seller_id);

        try {
            const response = await axios.post(Base_Url + dispute_action_admin, formData, {
                headers: {
                    'Content-Type': 'application/json',
                    'token': token,
                    'cus_id': cus_id,
                },
            });
            if (response.data.status === "SUCCESS") {
                toast.success(response.data.message);
                fetchAllDisputes();
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error("Error uploading data: " + error.message);
        }
    };

    const handleReject = async (row) => {
        const token = localStorage.getItem('token');
        const cus_id = localStorage.getItem('cus_id');

        const formData = new FormData();
        formData.append("waybill", row.waybill);
        formData.append("status", "Raise");
        formData.append("seller_id", row.seller_id);

        try {
            const response = await axios.post(Base_Url + dispute_action_admin, formData, {
                headers: {
                    'Content-Type': 'application/json',
                    'token': token,
                    'cus_id': cus_id,
                },
            });
            if (response.data.status === "SUCCESS") {
                toast.success(response.data.message);
                fetchAllDisputes();
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error("Error uploading data: " + error.message);
        }
    };

    const fetchAllDisputes = async () => {
        const token = localStorage.getItem('token');
        const cusid = localStorage.getItem('cus_id');
        try {
            const pageNumber = Number(page) || 1;
            const limitNumber = Number(limit) || 10;
            const urlweight = `${Base_Url}${weightList}?page=${pageNumber}&limit=${limitNumber}`;
            const response = await fetch(urlweight, {
                method: 'GET',
                headers: {
                    token,
                    cus_id: cusid,
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();
            if (result.status === "SUCCESS") {
                setweights(result.data);
                setTotalOrders(result.pagination.total_records);
            } else {
                toast.error(result.message || 'Failed to fetch weight disputes.');
            }
        } catch (error) {
            // toast.error('Something went wrong!');
        }
    };

    const handlePaginationChange = (event, value) => {
        setPage(value);
    };

    const handleLimitChange = (event) => {
        setLimit(event.target.value);
        setPage(1);
    };

    const handleViewClick = (weight) => {
        setSelectedweight(weight);
        setIsPopupOpen(true);
    };

    const handleClose = () => {
        setIsPopupOpen(false);
    };

    const handleNavigation = () => {
        navigate('/dashboard');
    };

    return (
        <>
            <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-black' : 'bg-gray-50'}`}>
                <div className="z-10 shrink-0">
                    <NavBar />
                </div>

                <div className="flex flex-1 overflow-hidden">
                    {isToggleSidebar && (
                        <div className={`fixed z-20 h-full w-64 md:relative duration-300 bg-white dark:bg-black dark:text-white md:bg-transparent md:w-64 md:z-20 border-r border-gray-200 dark:border-gray-800`}
                            style={
                                window.innerWidth < 768
                                    ? { top: "113px", height: "calc(100vh - 115px)", overflowY: 'auto' }
                                    : {}
                            }>
                            <Sidebar />
                        </div>
                    )}

                    <div className="flex-1 dark:bg-black p-3 md:p-4 w-full bg-gray-200 overflow-hidden flex flex-col">

                        {/* Header */}
                        <div className="flex-shrink-0 flex items-center gap-3 mb-3">
                            <div className="p-2 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900">
                                <FaWeight className="w-4 h-4 text-gray-600 dark:text-gray-400" />
                            </div>
                            <div>
                                <h1 className="text-sm font-bold text-gray-800 dark:text-white tracking-tight">Weight Disputes</h1>
                                <p className="text-[9px] text-gray-400 dark:text-gray-500">Manage and resolve weight dispute claims</p>
                            </div>
                            <span className="ml-auto text-[9px] font-medium text-gray-500 dark:text-gray-400 border border-gray-200 dark:border-gray-700 px-2.5 py-0.5 rounded-full">
                                {totalOrders} total
                            </span>
                        </div>

                        {/* Actions */}
                        <div className="flex-shrink-0 flex flex-col sm:flex-row items-center gap-2 mb-3">
                            <button
                                onClick={handleNavigation}
                                className="w-full sm:w-auto px-4 py-1.5 text-[10px] font-medium rounded-lg bg-gray-800 dark:bg-white text-white dark:text-gray-800 hover:opacity-80 transition-all flex items-center justify-center gap-1.5"
                            >
                                <FaWeight size={11} />
                                All Weight Disputes
                            </button>

                            <button
                                onClick={downloadCSV}
                                disabled={!weights || weights.length === 0}
                                className="w-full sm:w-auto px-4 py-1.5 text-[10px] font-medium rounded-lg border border-gray-600 dark:border-gray-600 text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-all flex items-center justify-center gap-1.5 disabled:opacity-40 disabled:cursor-not-allowed"
                            >
                                <FaDownload size={11} />
                                Download CSV
                            </button>
                        </div>

                        {/* Table */}
                        <div className="flex-1 overflow-y-auto overflow-x-auto rounded-lg border border-gray-200 dark:border-gray-700 custom-scrollbar">
                            <table className="min-w-full table-auto">
                                <thead className="bg-gray-800 dark:bg-white text-white dark:text-gray-800 text-[9px] uppercase tracking-wider sticky top-0 z-10">
                                    <tr>
                                        <th className='px-2.5 py-1.5 text-left font-semibold'>Seller ID</th>
                                        <th className='px-2.5 py-1.5 text-left font-semibold'>Waybill</th>
                                        <th className='px-2.5 py-1.5 text-left font-semibold'>Init. Wt</th>
                                        <th className='px-2.5 py-1.5 text-left font-semibold'>Dimension</th>
                                        <th className='px-2.5 py-1.5 text-left font-semibold'>Product</th>
                                        <th className='px-2.5 py-1.5 text-left font-semibold'>SKU</th>
                                        <th className='px-2.5 py-1.5 text-left font-semibold'>Rev. Wt</th>
                                        <th className='px-2.5 py-1.5 text-left font-semibold'>Price</th>
                                        <th className='px-2.5 py-1.5 text-left font-semibold'>Status</th>
                                        <th className='px-2.5 py-1.5 text-left font-semibold'>Date</th>
                                        <th className='px-2.5 py-1.5 text-left font-semibold'>Action</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-100 dark:divide-gray-800">
                                    {weights.map((weight, index) => (
                                        <tr
                                            key={weight.id}
                                            className="hover:bg-gray-50 dark:hover:bg-gray-800/30 transition-colors duration-150 bg-white dark:bg-gray-900"
                                        >
                                            <td className='px-2.5 py-1.5 text-[10px] text-gray-700 dark:text-gray-300 font-medium whitespace-nowrap'>{weight.seller_id}</td>
                                            <td className="px-2.5 py-1.5 text-[10px] text-gray-700 dark:text-gray-300 font-mono font-medium whitespace-nowrap">
                                                {weight.waybill}
                                            </td>
                                            <td className='px-2.5 py-1.5 text-[10px] text-gray-700 dark:text-gray-300 whitespace-nowrap'>{weight.initial_weight}</td>
                                            <td className='px-2.5 py-1.5 text-[10px] text-gray-700 dark:text-gray-300 whitespace-nowrap'>{weight.dimension}</td>
                                            <td className='px-2.5 py-1.5 max-w-[120px]'>
                                                {weight.product_des?.length > 15 ? (
                                                    <div className="group relative">
                                                        <span className="text-[10px] text-gray-700 dark:text-gray-300 cursor-pointer">
                                                            {weight.product_des.substring(0, 15)}...
                                                        </span>
                                                        <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-1.5 px-2 py-1 bg-gray-800 dark:bg-white text-white dark:text-gray-800 text-[9px] rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-50">
                                                            {weight.product_des}
                                                            <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-800 dark:border-t-white"></div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <span className="text-[10px] text-gray-700 dark:text-gray-300">{weight.product_des}</span>
                                                )}
                                            </td>
                                            <td className='px-2.5 py-1.5 text-[10px] text-gray-700 dark:text-gray-300 whitespace-nowrap'>{weight.sku}</td>
                                            <td className='px-2.5 py-1.5 text-[10px] text-gray-800 dark:text-white font-semibold whitespace-nowrap'>{weight.reversed_weight}</td>
                                            <td className='px-2.5 py-1.5 text-[10px] text-gray-800 dark:text-white font-semibold whitespace-nowrap'>₹{weight.price || 'N/A'}</td>
                                            <td className='px-2.5 py-1.5'>
                                                <span className={`inline-flex items-center px-1.5 py-0.5 rounded-full text-[9px] font-medium border ${
                                                    weight.status === 'Accept'
                                                        ? 'border-gray-800 dark:border-white text-gray-800 dark:text-white'
                                                        : weight.status === 'Reject' || weight.status === 'Raise'
                                                            ? 'border-gray-300 dark:border-gray-600 text-gray-400 dark:text-gray-500 line-through'
                                                            : weight.status === 'close'
                                                                ? 'border-gray-300 dark:border-gray-600 text-gray-400 dark:text-gray-500'
                                                                : weight.status === 'Pending'
                                                                    ? 'border-gray-800 dark:border-white text-gray-800 dark:text-white bg-gray-50 dark:bg-gray-800'
                                                                    : 'border-gray-200 text-gray-500'
                                                }`}>
                                                    <span className={`w-1 h-1 rounded-full mr-1 ${
                                                        weight.status === 'Accept' || weight.status === 'Pending'
                                                            ? 'bg-gray-800 dark:bg-white'
                                                            : 'bg-gray-400'
                                                    } ${weight.status === 'Pending' ? 'animate-pulse' : ''}`}></span>
                                                    {weight.status}
                                                </span>
                                            </td>
                                            <td className='px-2.5 py-1.5 text-[9px] text-gray-500 dark:text-gray-400 whitespace-nowrap'>{weight.timestamp}</td>
                                            <td className='px-2.5 py-1.5'>
                                                <div className='flex items-center gap-1'>
                                                    <button
                                                        onClick={() => handleViewClick(weight)}
                                                        className="w-7 h-7 flex items-center justify-center rounded-md border border-gray-300 dark:border-gray-600 text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 transition-all"
                                                        title="View"
                                                    >
                                                        <IoMdEye size={13} />
                                                    </button>
                                                    <button
                                                        onClick={() => handleAccept(weight)}
                                                        disabled={weight.status === "Accept" || weight.status === "close"}
                                                        className={`w-7 h-7 flex items-center justify-center rounded-md transition-all ${
                                                            weight.status === "Accept" || weight.status === "close"
                                                                ? 'border border-gray-200 dark:border-gray-700 text-gray-300 dark:text-gray-600 cursor-not-allowed'
                                                                : 'bg-gray-800 dark:bg-white text-white dark:text-gray-800 hover:opacity-80 border border-gray-800 dark:border-white'
                                                        }`}
                                                        title="Accept"
                                                    >
                                                        <MdCheckCircle size={13} />
                                                    </button>
                                                    <button
                                                        onClick={() => handleReject(weight)}
                                                        disabled={weight.status === "Accept" || weight.status === "close"}
                                                        className={`w-7 h-7 flex items-center justify-center rounded-md border transition-all ${
                                                            weight.status === "Accept" || weight.status === "close"
                                                                ? 'border-gray-200 dark:border-gray-700 text-gray-300 dark:text-gray-600 cursor-not-allowed'
                                                                : 'border-gray-300 dark:border-gray-600 text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800'
                                                        }`}
                                                        title="Reject"
                                                    >
                                                        <MdCancel size={13} />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                    {weights.length === 0 && (
                                        <tr>
                                            <td colSpan="11" className="p-6 text-center text-[10px] text-gray-400 dark:text-gray-500">
                                                No weight disputes found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {/* Pagination */}
                        <div className="flex-shrink-0 mt-2 pt-2 border-t border-gray-200 dark:border-gray-700 flex flex-col sm:flex-row justify-between items-center gap-2">
                            <span className="text-[9px] text-gray-500 dark:text-gray-400 font-medium">
                                Total: <span className="text-gray-800 dark:text-white font-semibold">{totalOrders}</span>
                            </span>
                            <div className="flex items-center gap-2">
                                <select
                                    id="limit"
                                    value={limit}
                                    onChange={handleLimitChange}
                                    className="border border-gray-300 dark:border-gray-600 rounded-lg px-2 py-0.5 text-[9px] bg-white dark:bg-black text-gray-700 dark:text-gray-300 focus:outline-none focus:ring-1 focus:ring-gray-400"
                                >
                                    <option value={10}>10</option>
                                    <option value={15}>15</option>
                                    <option value={20}>20</option>
                                    <option value={totalOrders}>All</option>
                                </select>
                                <Pagination
                                    count={Math.ceil(totalOrders / limit)}
                                    page={page}
                                    onChange={handlePaginationChange}
                                    variant="outlined"
                                    shape="rounded"
                                    size="small"
                                    sx={{
                                        '& .MuiPaginationItem-root': {
                                            fontSize: '9px',
                                            borderColor: isDarkMode ? '#374151' : '#d1d5db',
                                            color: isDarkMode ? '#fff' : '#000',
                                            '&.Mui-selected': {
                                                backgroundColor: isDarkMode ? '#fff' : '#000',
                                                color: isDarkMode ? '#000' : '#fff',
                                            },
                                        },
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <ViewWeightDisputes isopen={isPopupOpen} onClose={handleClose} allWeightDisputes={selectedweight} />
            </div>
        </>
    );
};

export default AllWeightDisputes;